<template>
  <div class="apps-list">

    <AppCard v-for="job in jobs" :key="job.id" 
        :params="job"
    />
  </div>
</template>

<script setup>
import {ref, watch, computed,onMounted} from 'vue';

import SVGIcon from '@/components/SVGIcon.vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import AppCard from '@/components/Apps/AppRunning.vue';

const $toast = useToast();
const store = useStore();

const loading = ref(false);
const jobs = ref(null);

const dataConnect = new DatastoreConnect();

 onMounted(async () => {
  dataConnect.api('job.list',{})
  .then((ret) => {
    if(ret.result){
    jobs.value=ret.result;
  }
  if(ret.error){
    const $toast = useToast();
          $toast.open({
            queue: true,
            duration: 5000,
            message: ret.error.message,
            type: 'error',
            position: 'top',
          });
        }
  })
   .catch((error) => {
      console.log(error);
      return '';
    });
  

  
       
});


</script>

<style lang="scss" scoped>

.apps-list {
  padding: 10px;  
  overflow: scroll;
}

</style>
